import { StoreIcon } from 'lucide-react';

export const NavCustomer = StoreIcon;
